module.exports = __webpack_public_path__ + "img/icon_map_jsbs_c.0ebcdddd.png";